export const useSiteId = (): number => {
    const { locales, locale } = useI18n();
    const craftSiteId = locales.value.find(l => l.code === locale.value)?.craftSiteId;

    return typeof craftSiteId === 'number' ? craftSiteId : 1;
};
